// removed by extract-text-webpack-plugin
module.exports = {"heading":"HeadingCurved__heading___24g_F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeadingCurved/HeadingCurved.css
// module id = 875
// module chunks = 0